module.exports = __webpack_public_path__ + "static/media/transform-icon-active.5e1e03e7.svg";